const handleUserSetFirebaseLogoutFunction = (state, action) => {
    let newState = { ...state };
    newState.logout = action.payload;
    return newState;
};

const handleSetUser = (state, action) => {
    let newState = { ...state };
    newState.user = action.payload;
    return newState;
};

const handleUserSetLoading = (state, action) => {
    let newState = { ...state };
    newState.loading = action.payload;
    return newState;
};

export const userReducer = (
    state = { user: null, loading: true, logout: () => {} },
    action
) => {
    switch (action.type) {
        case "USER_SET_FIREBASE_LOGOUT_FUNCTION":
            return handleUserSetFirebaseLogoutFunction(state, action);
        case "USER_SET_USER":
            return handleSetUser(state, action);
        case "USER_SET_LOADING":
            return handleUserSetLoading(state, action);
        default:
            return state;
    }
};
